export default class ModalCatalog {
    constructor(categories) {
        this.parentList = categories;
        this.parents = this.parentList.querySelectorAll(':scope > .menu-catalog-category');
        this.eventRegister();
    }

    eventRegister() {
        this.parents.forEach((item) => {
            item.onmouseenter = () => {
                this.openChildList(item);
            };
        });

        document.addEventListener('closeModalCatalog', () => {
            this.reset();
        });
    }

    openChildList(parent) {
        this.reset();

        const childUl = parent.querySelector('.header-desktop__catalog-right');
        const rightContainer = document?.querySelector('.header-desktop__container-right');
        if (!childUl || !rightContainer) return;

        const placeholder = document.createElement('span');
        placeholder.style.display = 'none';

        childUl.after(placeholder);

        childUl._placeholder = placeholder;

        if (rightContainer) {
            rightContainer.append(childUl);
            childUl.style.display = 'flex';
            this.addHoverStyle(parent);
        }
    }

    addHoverStyle(element) {
        element.classList.add('header-desktop__catalog-left_active');
    }

    reset() {
        const rightContainer = document?.querySelector('.header-desktop__container-right');
        const childUl = rightContainer?.querySelector(':scope > .header-desktop__catalog-right');
        if (!childUl) return;

        const placeholder = childUl._placeholder;
        if (!placeholder) return;

        placeholder.before(childUl);
        childUl.parentElement.classList.remove('header-desktop__catalog-left_active');
        childUl.style.display = '';
    }

    addRightContainer() {
        const modalContainer = document.querySelector('.header-desktop__catalog-modal-container');
        if (!modalContainer) return;

        const possibleDuplicate = modalContainer.querySelector('.header-desktop__container-right');
        if (possibleDuplicate) return;

        const containerRight = document.createElement('div');
        containerRight.classList.add('header-desktop__container-right');
        modalContainer.appendChild(containerRight);
    }
    deleteRightContainer() {
        const rightContainer = document?.querySelector('.header-desktop__container-right');
        if (rightContainer) {
            rightContainer.remove();
        }
    }
}
